import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {WLUtils} from '../utils/WLUtils.js';
import {CoroutineManager} from '../classes/coroutines/CoroutineManager.js';
import {Puzzle} from './puzzle.js';
import {GameFlowController} from './game-flow-controller.js';
import {NotificationLevel} from '../enums/NotificationLevel.js';
import {waitForCondition} from '../classes/coroutines/YieldInstructions.js';
import {Localization} from '../utils/Localization.js';
import {Coroutine} from '../classes/coroutines/Coroutine.js';
import {UIModel} from '../models/UIModel.js';
import {PopupWindowController} from '../ui/panels/popup-window.js';
import {BooleanName} from '../enums/BooleanName.js';
import {BooleanStore} from './boolean-store.js';

export class TutorialEasyMode extends Component {
    static TypeName = 'tutorial-easy-mode';

    @property.object({required: true})
    popFinger!: Object3D;

    private _coroutineManager = new CoroutineManager();

    start() {
        WLUtils.setActive(this.popFinger, false);
    }

    update(delta: number): void {
        this._coroutineManager.update(delta);
    }

    startTutorial() {
        this._coroutineManager.stopCoroutine(this._runTutorialId);
        this._runTutorialId = this._coroutineManager.addCoroutine(
            new Coroutine(this._runTutorial())
        );
    }

    private _runTutorialId = -1;
    private *_runTutorial() {
        UIModel.instance.setTutorialHUDActive(true);
        const puzzle = Puzzle.instance;
        const scoreController = puzzle.score;
        const gameFlowController = GameFlowController.instance;
        const dropspeed = puzzle.dropSpeedFactor;
        gameFlowController.notificationsAllowed = NotificationLevel.None;
        const popup = PopupWindowController.instance;

        yield* waitForCondition(() => puzzle.gameInProgress);

        let loadedObjectCount = puzzle.loadedObjectCount();
        yield* waitForCondition(() => puzzle.loadedObjectCount() != loadedObjectCount);

        let startingNumberOfBlobs = puzzle.objectCount();
        popup.show(Localization.instance.get('TutorialHowToPop'), false);
        WLUtils.setActive(this.popFinger, true);
        puzzle.dropSpeedFactor = 0;
        const loadedObjPos = puzzle.findFirstLoadedObjectWithFruit();
        const obj = puzzle.getObject(loadedObjPos.row, loadedObjPos.column);
        this.popFinger.parent = obj.object;
        this.popFinger.resetPositionRotation();

        yield* waitForCondition(() => puzzle.objectCount() < startingNumberOfBlobs);

        // end tutorial
        BooleanStore.instance.set(BooleanName.EasyModeTutorialPlayed, true);
        popup.hide();
        UIModel.instance.setTutorialHUDActive(false);
        puzzle.dropSpeedFactor = dropspeed;
    }
}
